/***
 *
 *   PAGINATE STYLES
 *   Ported from ui-reference/src/components/ui/table-pagination.tsx — a
 *   top-bordered footer row with the range on the left and the controls right.
 *
 **********/

const Style = {
    paginate:
        'flex shrink-0 flex-col gap-3 border-t border-border pt-3 sm:flex-row sm:items-center sm:justify-between',
    label: 'text-xs text-text-secondary',
    controls: 'flex flex-wrap items-center gap-3',
    buttons: 'flex items-center gap-1',
    button: 'h-8 px-2',
    counter: 'text-xs tabular-nums text-text-secondary',
    sizeLabel: 'flex items-center gap-2 text-xs text-text-secondary',
    select: `h-8 rounded-md border border-border bg-surface px-2 text-sm text-text-primary
    transition-colors hover:border-text-muted focus-visible:outline-none focus-visible:ring-2
    focus-visible:ring-ring`,
};

export default Style;
